import { AccessGuids, AlertClassColour, ApplicationNames, ConfigSystemParamDefaults, ConfigSystemParams, modalFormValues, msSize, TypeDevice, TypeDeviceInt } from 'src/app/core/consts';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, ReplaySubject, takeUntil, throwError, timer } from 'rxjs';
import { CommConfigService } from 'src/app/core/services/utelize/system/communication/comm-config-service';
import { CommunicationTemplate } from 'src/app/core/models/system/communication/communication-template';
import { CommunicationTemplateDTO } from 'src/app/core/models/system/communication/communication-template.dto';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyModalFormComponent } from '../../_company/company-modal-form/company-modal-form.component';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DashboardService } from 'src/app/core/services/utelize/general/dashboard-service';
import { DeliveryType, DeviceActivationType, DeviceOSType, eDeviceType, eUser, MessageType } from 'src/app/core/enums';
import { DeviceDTO } from 'src/app/core/models/system/device/device.dto';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { EsimProvisioningDTO } from 'src/app/core/models/system/provisioning/esim-provisoning.dto';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InviewCompaniesService } from 'src/app/core/services/utelize/inview/inview-companies-service';
import { InviewUserDTO } from 'src/app/core/models/inview/inview-user.dto';
import { InviewUsersService } from 'src/app/core/services/utelize/inview/inview-users-service';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductsService } from 'src/app/core/services/utelize/system/product/products-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TypesDeviceService } from 'src/app/core/services/utelize/system/type/types-device-service';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UserModalFormComponent } from '../../_user/user-modal-form/user-modal-form.component';
import { UserModalFormSearchComponent } from '../../_user/user-modal-form-search/user-modal-form-search.component';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { ValidatorService } from 'src/app/core/services/utelize/general/validator-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-provision-modal-form',
  templateUrl: './provision-modal-form.component.html',
  styleUrls: ['./provision-modal-form.component.scss']
})

export class ProvisionModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() embeddedFormMode      : boolean | undefined;
  @Input() initialInviewCompanyId: number  | undefined;

  @Output() iccidHasBeenProvisioned          : EventEmitter<void>=new EventEmitter<void>();
  @Output() provisionESIMFormHasBeenCancelled: EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('companyModalForm',          { static: false }) companyModalForm!         : CompanyModalFormComponent;
  @ViewChild('completedModalForm',        { static: false }) completedModalForm!       : CompletedModalFormComponent;
  @ViewChild('eidfield',                  { static: false }) eidInput!                 : ElementRef<HTMLInputElement>;
  @ViewChild('provisionModalFormContent', { static: false }) provisionModalFormContent!: TemplateRef<void>;
  @ViewChild('userModalForm',             { static: false }) userModalForm!            : UserModalFormComponent;
  @ViewChild('userSearchForm',            { static: false }) userSearchForm!           : UserModalFormSearchComponent;
  @ViewChild('warningModalForm',          { static: false }) warningModalForm!         : WarningModalFormComponent;

  get canEditCustomiseMessage      () { return this.authenticationService.canEditSystemOwned(this.customiseMessageTemplate?.systemOwned ?? false);        }
  get customiseMessageCharacters   () { return this.customiseMessageText().length;                                                                        }
  get customiseMessageDefaultText  () { return this.deliveryMethod == 'sms'    ? this.defaultProvisionViaSMSText    :
                                               this.deliveryMethod == 'manual' ? this.defaultProvisionViaManualText : this.defaultProvisionViaEmailText;  }
  get customiseMessageReplacements () { return this.deliveryMethod == 'sms'    ? this.templateSMSReplacements       :
                                               this.deliveryMethod == 'manual' ? this.templateManualReplacements    : this.templateEmailReplacements;     }
  get customiseMessageTemplate     () { return this.deliveryMethod == 'sms'    ? this.smsTemplate                   :
                                               this.deliveryMethod == 'manual' ? this.manualTemplate                : this.emailTemplate;                 }
  get customiseMessageTitle        () { return this.deliveryMethod == 'sms'    ? "Customise SMS message" : "Customise email message";                     }
  get defaultProvisionViaEmailText () { return this.configSystemService.getValue(ConfigSystemParams.CommunicationTemplatesProvisionViaEmailText,  "");    }
  get defaultProvisionViaManualText() { return this.configSystemService.getValue(ConfigSystemParams.CommunicationTemplatesProvisionViaManualText, "");    }
  get defaultProvisionViaSMSText   () { return this.configSystemService.getValue(ConfigSystemParams.CommunicationTemplatesProvisionViaSMSText,    "");    }
  get showSMSEmail                 () { return this.configSystemService.getValue(ConfigSystemParams.ShowPushViaSMSEmail,                          "");    }
  get modalBackGround              () { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                                        return value=value.toUpperCase()=="STATIC" ? "static"              : (value.toUpperCase()=="TRUE" ? true : false);}
  get mustHaveLicence              () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesPlatformMustHaveForProvision, false);}

  get showManualProvisioningButton () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ProvisioningShowManualButton, true        ) &&
                                               this.componentAccessUserService.hasAccessGuid(AccessGuids.FormProvisionManualProvisionButton            ); }

  private completedOrderStatus          : string="Provisioned";
  private customiseMessageOriginalText  : string="";
  private device                        : DeviceDTO | undefined;
  private deviceIdData!                 : IdAndDescriptionDTO[];
  private deviceTypeIdData!             : IdAndDescriptionDTO[];
  private initialInviewCompanyIdSet     : boolean=false;
  private initialSelectedDeviceIdSet    : boolean=false;
  private initialSelectedDeviceTypeIdSet: boolean=false;
  private initialStatus                 : string="Please complete the following details";
  private initialOrderStatus            : string="Pending";
  private inviewCompanyIdData!          : IdAndDescriptionDTO[];
  private inviewUserIdData!             : InviewUserDTO[];
  private statusObservable              : Observable<number> | undefined;
  private productIdData!                : IdAndDescriptionDTO[];
  private selectedDeviceId              : number=-1;
  private selectedDeviceTypeId          : number=-1;
  private selectedICCID                 : string="";
  private statusCheck                   : ReplaySubject<boolean> = new ReplaySubject(1);
  private sureSimCompanyId              : number | undefined;
  private sureSimUserId                 : number | undefined;

  public addCompanyButtonEnabled        : boolean=true;
  public addUserButtonEnabled           : boolean=false;
  public alertColourOrderStatus         : string=AlertClassColour.Grey;
  public alertColourProgress            : string=AlertClassColour.Grey;
  public availableOnly                  : boolean=false;
  public breadCrumbItems!               : Array<{}>;
  public curUser                        : SystemUserDTO;
  public customiseMessageBody           : string="";
  public customiseMessageExpanded       : boolean=false;
  public customiseMessageForm!          : UntypedFormGroup;
  public deliveryMethod                 : string = '';
  public DeviceActivationTypePushViaSMSEmail: number=DeviceActivationType.SendViaSMSEmail;
  public deviceType                     : string = '';
  public emailTemplate                  : CommunicationTemplateDTO | undefined;
  public exsitingReservedeSimsCount     : number=0;
  public exsitingReservedSimsCount      : number=0;
  public formSubmitted                  : boolean=false;
  public formTitle                      : string="SureSIM Provision";
  public manualActivationCode           : string | undefined;
  public manualActivationDetailsVisible : boolean=false;
  public manualActivationServer         : string | undefined;
  public manualTemplate                 : CommunicationTemplateDTO | undefined;
  public noICCIDData                    : boolean=false;
  public orderStatusInformation         : string=this.initialOrderStatus;
  public physicalSimSelected            : undefined | boolean;
  public preventAutofill                : boolean=true;
  public provisioningForm!              : UntypedFormGroup;
  public provisioningInProgress         : boolean=false;
  public progressInformation            : string=this.initialStatus;
  public randomEsim                     : boolean=false;
  public registerInviewCompany          : boolean=false; 
  public registerInviewUser             : boolean=false;
  public reservedOnly                   : boolean=false;
  public searchForInviewUser            : boolean=false;
  public selectedInviewCompany?         : IdAndDescriptionDTO;
  public selectedInviewCompanyId        : number | undefined;
  public selectedInviewUser?            : InviewUserDTO;
  public selectedInviewUserId           : number | undefined;
  public selectedSureSimUser?           : UserDTO;
  public simReservationCount            : number=0;
  public smsTemplate                    : CommunicationTemplateDTO | undefined;
  public templateEmailReplacements      : CommunicationTemplateReplacements[] = [];
  public templateManualReplacements     : CommunicationTemplateReplacements[] = [];
  public templateSMSReplacements        : CommunicationTemplateReplacements[] = [];
  public totalLiveDevices               : number=0;
  public totalPlatformLicences          : number=0;
  public totalRemainingLicences         : number=0;
  public usedLicencePercentage          : number=0;
  public warningMessageMain             : string | undefined;
  public warningMessageSub              : string | undefined;

  public deliveryMethods = [
    { id: 'eid',    label: 'EID',    icon: '📱', desc: 'Direct eSIM push via device EID'       },
    { id: 'sms',    label: 'SMS',    icon: '💬', desc: 'Send activation link via text message' },
    { id: 'email',  label: 'Email',  icon: '✉️', desc: 'Send activation link via email'        },
    { id: 'manual', label: 'Manual', icon: '📄', desc: 'Display activation details on screen'  }
  ];

  public deviceTypes = [
    { id: 'ios',     label: 'iOS',     icon: '🍏', desc: 'iPhone / iPad' },
    { id: 'android', label: 'Android', icon: '🤖', desc: 'Samsung, Pixel, etc.' },
    { id: 'windows', label: 'Windows', icon: '💻', desc: 'Windows 11 eSIM devices' }
  ];

  get filteredDeviceTypes() {
    if (this.deliveryMethod==="sms") {
      return this.deviceTypes.filter(d => d.id === 'ios' || d.id === 'android')
    } else {
      return this.deviceTypes;
    }
  }

  constructor(
    private authenticationService          : AuthenticationService,
    private commConfigsService             : CommConfigService,
    private companiesService               : CompaniesService,
    private componentAccessUserService     : ComponentAccessUserService,
    private configSystemService            : ConfigSystemService,
    private dashboardService               : DashboardService,
    private exceptionsService              : ExceptionsService,
    private devicesService                 : DevicesService,
    private formBuilder                    : UntypedFormBuilder,
    private inviewCompaniesService         : InviewCompaniesService,
    private inviewUsersService             : InviewUsersService,
    private lastPassKillerService          : LastPassKillerService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService,
    private modalService                   : NgbModal,
    private productsService                : ProductsService,
    private typesDeviceService             : TypesDeviceService,
    private usersService                   : UsersService,
    private validatorService               : ValidatorService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.orderStatusInformation=this.initialOrderStatus;

      if (this.embeddedFormMode) {
        this.startProcess(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    try {
      this.lastPassKillerService.stop();
      this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeForm(): void {
    try {
      if (!this.embeddedFormMode) {
        this.statusCheck.next(true);
        this.statusCheck.complete();
      }
      this.provisionESIMFormHasBeenCancelled.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(isFormOpening : boolean, companyOnChange : boolean): void {
    try {
      this.addCompanyButtonEnabled        =true;
      this.addUserButtonEnabled           =false;
      this.alertColourProgress            =AlertClassColour.Grey;
      this.customiseMessageExpanded       =false;
      this.deviceIdData                   =[];
      this.formSubmitted                  =false;
      this.manualActivationCode           =undefined;
      this.manualActivationDetailsVisible =false;
      this.manualActivationServer         =undefined;
      this.progressInformation            =this.initialStatus;
      this.provisioningInProgress         =false;
      this.registerInviewCompany          =false;
      this.registerInviewUser             =false;
      this.searchForInviewUser            =false;
      this.selectedInviewCompanyId        =undefined;
      this.selectedInviewUserId           =undefined;
      this.selectedSureSimUser            =undefined;
      this.totalLiveDevices               =0;
      this.totalPlatformLicences          =0;
      this.totalRemainingLicences         =0;
      this.updateProvisioningStatus(this.initialOrderStatus, false);

      if (isFormOpening) {
        this.initialInviewCompanyIdSet=false;
      }

      if (!companyOnChange) {
        this.initialSelectedDeviceIdSet     =false;
        this.initialSelectedDeviceTypeIdSet =false;
      }

      if (this.embeddedFormMode == true && !companyOnChange) {
        this.physicalSimSelected=undefined;
        this.randomEsim         =true;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(iccid :string, deviceTypeId :number, companyId :number, reservedOnly :boolean, availableOnly :boolean, eSimReservationCount :number, simReservationCount :number): void {
    try {
      this.availableOnly          = availableOnly;
      this.embeddedFormMode       = false;
      this.initialInviewCompanyId = companyId;
      this.physicalSimSelected    = deviceTypeId == -1 ? undefined : deviceTypeId == TypeDeviceInt.SIM;
      this.randomEsim             = deviceTypeId == -1;
      this.reservedOnly           = this.physicalSimSelected ?? false; //reservedOnly;
      this.selectedDeviceTypeId   = deviceTypeId;
      this.selectedICCID          = iccid;

      this.startProcess(true);
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.modalService.open(this.provisionModalFormContent, { backdrop: this.modalBackGround, 
                                                               centered: true,
                                                               keyboard: false,
                                                               size    : msSize.Large });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private startProcess(IsFormOpening : boolean): void {
    try {
      this.resetMainVariables(IsFormOpening, false);
      this.refreshInviewCompanyData();
      this.refreshProductData();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region provisioningForm

  get formData() {
    return this.provisioningForm.controls;
  }

  private setUpForm() {
    try {
      this.getDevice();
      this.buildForm();
      this.enableDisableControls(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.provisioningForm=this.formBuilder.group({ });

      this.addFormFields(this.provisioningForm);

      this.buildCustomiseMessageForm();

      this.setOrClearValidators();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.provisioningForm) {
        this.addFormControl(formGroup, "eid",             "",                  [Validators.required, Validators.minLength(32), Validators.maxLength(32), Validators.pattern('^[0-9]{32,32}$')]);
        this.addFormControl(formGroup, "deviceTypeId",    "",                  [Validators.required]);
        this.addFormControl(formGroup, "iccid",           this.selectedICCID,  []);
        this.addFormControl(formGroup, "inviewCompanyId", "",                  [Validators.required]);
        this.addFormControl(formGroup, "inviewUserId",    "",                  [Validators.required]);
        this.addFormControl(formGroup, "orderGuid",       crypto.randomUUID(), [])
        this.addFormControl(formGroup, "productId",       "",                  [Validators.required]);

        if (this.physicalSimSelected ?? true) {
          this.addFormControl(formGroup, "deviceId",         undefined,        [Validators.required]);
        } else {
          this.addFormControl(formGroup, "deviceId",         undefined,        []);
        }

        if (!this.showSMSEmail) {
          this.deviceType='';
          this.deliveryMethod='eid';
        }

      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public saveFormData() {
    try {
      this.formSubmitted=true;
      
      if (this.provisioningForm.valid) {
        let esimProvisioningDTO: EsimProvisioningDTO={
          activationTypeId: this.deliveryMethod == 'eid'    ? DeviceActivationType.PushViaEID  :
                            this.deliveryMethod == 'manual' ? DeviceActivationType.SendViaManual :
                                                              DeviceActivationType.SendViaSMSEmail,
          deviceId        : this.provisioningForm.controls["deviceId"].value,
          deviceOSTypeId  : this.deliveryMethod == "email" ? DeviceOSType.Windows : this.deviceType == "android" ? DeviceOSType.Android : DeviceOSType.AppleIOS, 
          deviceTypeId    : this.provisioningForm.controls["deviceTypeId"].value,
          eid             : this.provisioningForm.controls["eid"].value,
          enteredBy       : this.curUser.userId,
          iccid           : this.physicalSimSelected == true || !this.embeddedFormMode ? this.provisioningForm.controls["iccid"].value : null,
          inviewCompanyId : this.provisioningForm.controls["inviewCompanyId"].value,
          inviewUserId    : this.provisioningForm.controls["inviewUserId"].value,
          orderGuid       : this.provisioningForm.controls["orderGuid"].value,
          orderNumber     : "",
          productId       : this.provisioningForm.controls["productId"].value,
          provisionTypeId : 1,
          reserved        : this.reservedOnly
        }

        this.saveCustomiseMessage(() => this.doProvisioning(esimProvisioningDTO));
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      if (enabled) {
        if (this.showSMSEmail) {
        }
        this.provisioningForm.controls["deviceId"].enable();
        this.provisioningForm.controls["deviceTypeId"].enable();
        this.provisioningForm.controls["eid"].enable();
        this.provisioningForm.controls["inviewUserId"].enable();
        this.provisioningForm.controls["productId"].enable();

      } else {
        this.provisioningForm.controls["deviceId"].disable();
        this.provisioningForm.controls["deviceTypeId"].disable();
        this.provisioningForm.controls["eid"].disable();
        this.provisioningForm.controls["inviewUserId"].disable();
        this.provisioningForm.controls["productId"].disable();
      }
      
      this.addUserButtonEnabled  =enabled;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private disableAllControls(includeInviewCompanyId: boolean) {
    try {
      //iccd already disabled
      this.provisioningForm.controls["deviceId"].disable();
      this.provisioningForm.controls["deviceTypeId"].disable();
      this.provisioningForm.controls["eid"].disable();

      if (includeInviewCompanyId)
        this.provisioningForm.controls["inviewCompanyId"].disable();

      this.provisioningForm.controls["inviewUserId"].disable();
      this.provisioningForm.controls["productId"].disable();
      
      this.addCompanyButtonEnabled =false;
      this.addUserButtonEnabled    =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  //#endregion

  //#region Templates

  private getTemplateData(messageType : number, deliveryType : number) {
    try {
      if (this.sureSimCompanyId != undefined && this.sureSimCompanyId>0) { 
        this.commConfigsService.getCommunicationTemplate(this.sureSimCompanyId as number, messageType, deliveryType)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
        .subscribe({
          next: data => {
              if (data.messageTypeId == MessageType.ProvisioningViaEmail)
                this.emailTemplate=data;
              if (data.messageTypeId == MessageType.ProvisioningViaSMS)
                this.smsTemplate=data;
              if (data.messageTypeId == MessageType.ProvisioningViaManual)
                this.manualTemplate=data;

              this.refreshCustomiseMessage();
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
          })
        }
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
         return (undefined);
      }
    }

  private getTemplateReplacements() {
    try {
      this.commConfigsService.getCommunicationTemplateReplacements(this.curUser.userId, MessageType.ProvisioningViaEmail).subscribe(x => this.templateEmailReplacements = x);
      this.commConfigsService.getCommunicationTemplateReplacements(this.curUser.userId, MessageType.ProvisioningViaSMS).subscribe(x => this.templateSMSReplacements = x);
      this.commConfigsService.getCommunicationTemplateReplacements(this.curUser.userId, MessageType.ProvisioningViaManual).subscribe(x => this.templateManualReplacements = x);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Customise Message

  private buildCustomiseMessageForm(): void {
    try {
      this.customiseMessageForm=this.formBuilder.group({ });

      this.addFormControl(this.customiseMessageForm, "messageBody", "", []);

      this.populateCustomiseMessage();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260825 - Mirrors the backend which appends these at send time.
  private insertMandatorySystemValues(body: string): string {
    try {
      let updatedBody=(body ?? "").replace(/\r\n/g, "\n");

      if (this.deliveryMethod=='sms' || this.deliveryMethod=='email') {
        if (!updatedBody.includes("@@ActivationLink")) {
          updatedBody+="\n\n@@ActivationLink";
        }
      }

      if (this.deliveryMethod=='manual') {
        if (!updatedBody.includes("@@ActivationServer")) {
          updatedBody+="\n\nActivation Server: @@ActivationServer";
        }

        if (!updatedBody.includes("@@ActivationCode")) {
          updatedBody+="\nActivation Code: @@ActivationCode";
        }
      }

      return updatedBody;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return body;
    }
  }

  private populateCustomiseMessage(): void {
    try {
      const template=this.customiseMessageTemplate;

      this.customiseMessageOriginalText=template==undefined ? "" : this.insertMandatorySystemValues(template.body ?? "");

      this.customiseMessageBody=this.customiseMessageOriginalText;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private refreshCustomiseMessage(): void {
    try {
      if (this.customiseMessageText()==this.customiseMessageOriginalText) {
        this.populateCustomiseMessage();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveCustomiseMessage(onSaved: () => void): void {
    try {
      const template=this.customiseMessageTemplate;
      const body    =this.customiseMessageText();

      if (!this.customiseMessageVisible() || !this.canEditCustomiseMessage || template==undefined ||
          body.trim()=="" || body==this.customiseMessageOriginalText) {
        onSaved();
        return;
      }

      this.provisioningInProgress=true;

      const saveBody: CommunicationTemplate={
        AlertTypeId         : template.alertTypeId,
        ID                  : template.id,
        CommunicationTypeId : template.communicationTypeId,
        CompanyId           : this.sureSimCompanyId,
        DeliveryTypeId      : this.deliveryMethod=='sms' ? DeliveryType.SMS : DeliveryType.Email,
        MessageTypeId       : template.messageTypeId,
        Name                : template.name,
        Subject             : template.subject,
        Body                : body,
        CC                  : template.cc,
        BCC                 : template.bcc,
        FromEmail           : template.fromEmail,
        FromNumber          : template.fromNumber,
        SendToUser          : template.sendToUser,
        SendElsewhere       : template.sendElsewhere,
        ToEmail             : template.toEmail,
        ToNumber            : template.toNumber,
        UseDefaultCC        : template.useDefaultCC,
        UseDefaultBCC       : template.useDefaultBCC,
        UseDefaultFromEmail : template.useDefaultFromEmail,
        UseDefaultFromNumber: template.useDefaultFromNumber,
        UseDefaultToEmail   : template.useDefaultToEmail,
        UseDefaultToNumber  : template.useDefaultToNumber,
        EnteredBy           : this.curUser.userId,
        Active              : true,
        Deleted             : false,
        SystemOwned         : false
      };

      (template.id>0 ? this.commConfigsService.editCommunicationTemplate(saveBody)
                     : this.commConfigsService.createCommunicationTemplate(saveBody))
      .pipe(
        catchError((error) => {
          this.provisioningInProgress=false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: id => {
          if (template.id<=0) {
            template.id=id;
          }

          template.body                    =body;
          this.customiseMessageOriginalText=body;
          this.provisioningInProgress      =false;

          onSaved();
        },
        error: error => {
          this.provisioningInProgress=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.provisioningInProgress=false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public customiseMessageInvalidPlaceHolders(): string {
    try {
      const replacements    =this.customiseMessageReplacements ?? [];
      let   invalidPlaceHolders="";

      this.customiseMessageText()
          .trim()
          .replace(/\,/," ")
          .replace(/@@/g," @@")
          .split(/\s+/)
          .forEach(word => {
            if (word.startsWith('@@') && !replacements.some(x => word.startsWith(x.placeHolder ?? ""))) {
              invalidPlaceHolders+=',' + word;
            }
          });

      return invalidPlaceHolders=="" ? "" : invalidPlaceHolders.substring(1);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public customiseMessageWarning(): string {
    try {
      if (this.customiseMessageIsValid()) {
        return "";
      }

      return this.customiseMessageInvalidPlaceHolders()=="" ? "A message is required" : "Unknown system value(s) found";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public customiseMessageIsValid(): boolean {
    try {
      if (!this.customiseMessageVisible()) {
        return true;
      }

      return this.customiseMessageText().trim()!="" && this.customiseMessageInvalidPlaceHolders()=="";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  }

  public customiseMessageText(): string {
    try {
      return this.customiseMessageBody ?? "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public customiseMessageVisible(): boolean {
    try {
      return this.sendingToVisible() && this.customiseMessageTemplate != undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //RBW_20261020 - The panel resets to whatever this returns, so the mandatory values are folded in here rather
  //               than the panel having to know about them.
  public customiseMessageResetText(): string {
    try {
      return this.insertMandatorySystemValues(this.customiseMessageDefaultText);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public onCustomiseMessageExpandedChange(expanded: boolean): void {
    try {
      if (expanded) {
        this.refreshCustomiseMessage();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Sending To

  public sendingToDescription(): string {
    try {
      if (this.deliveryMethod=='manual') {
        return "A copy of the activation details will be sent to this address.";
      }

      if (this.sendingToMissing()) {
        return this.deliveryMethod=='sms' ? "This user has no mobile number on their user profile, so the SMS cannot be sent."
                                          : "This user has no email address on their user profile, so the email cannot be sent.";
      }

      return this.deliveryMethod=='sms' ? "An SMS will be sent to the mobile number on the user's profile."
                                        : "An email will be sent to the email address on the user's profile.";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public sendingToMissing(): boolean {
    try {
      return this.sendingToVisible() && this.deliveryMethod != 'manual' && this.selectedSureSimUser != undefined && this.sendingToValue()=="";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public sendingToValue(): string {
    try {
      if (this.deliveryMethod=='manual') {
        return this.curUser.username;
      }

      if (this.deliveryMethod=='email') {
        return this.selectedSureSimUser?.email ?? "";
      }

      const mobile=this.selectedSureSimUser?.mobile ?? "";

      return mobile.trim() != "" ? mobile : this.selectedSureSimUser?.mobileE164 ?? "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public sendingToVisible(): boolean {
    try {
      if (this.physicalSimSelected==true || !(this.totalRemainingLicences>0 || !this.mustHaveLicence)) {
        return false;
      }

      if (this.deliveryMethod=='manual') {
        return true;
      }

      return (this.deliveryMethod=='sms' || this.deliveryMethod=='email') && this.selectedInviewUser != undefined && this.deviceType != '';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //#endregion

  //#region Device

  public getDevice() {
    this.device= <DeviceDTO>{id:0, imeiIccid:"TBD", supplierID:1, allocated:false, active:true, enteredBy:1, batchID:0, defaultProductID:0, deviceTypeID:1,msisdn:"",reservedCompanyID:0};
  }

  public allocateDevice() {
    try {
      if (this.device != undefined && this.device.id>0) {
        this.devicesService.allocate(this.device.id)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {

          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setDeviceType(type: string) {
    this.deviceType = type;
  }

  //#endregion

  //#region Delivery

  public selectMethod(id: string) {
    this.customiseMessageExpanded       = false;
    this.deliveryMethod = id;
    this.deviceType = '';
    this.manualActivationDetailsVisible = false;
    this.manualActivationCode           = undefined;
    this.manualActivationServer         = undefined;

    this.populateCustomiseMessage();

    this.setOrClearValidators();
  }

  public copyToClipboard(value: string | undefined): void {
    try {
      if (value != undefined && value != '') {
        navigator.clipboard.writeText(value);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="inviewCompanyId") {
        return this.inviewCompanyIdData;

      } else if (fieldName=="deviceId") {
        return this.deviceIdData;

      } else if (fieldName=="deviceTypeId") {
        return this.deviceTypeIdData;

      } else if (fieldName=="productId") {
        return this.productIdData;
      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  public getDropdownDataObjectArray_InviewUser() {
    try {
      return this.inviewUserIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="inviewCompanyId") {
              this.inviewCompanyIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialInviewCompanyIdSet && this.initialInviewCompanyId != undefined && this.initialInviewCompanyId>0) {
                this.provisioningForm.controls["inviewCompanyId"].setValue(this.initialInviewCompanyId);
                
                this.initialInviewCompanyIdSet=true;
              }

              this.inviewCompanySelectDropDownChange(undefined);

            } else if (fieldName=="deviceId") {
              this.deviceIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialSelectedDeviceIdSet && this.selectedICCID != undefined && this.selectedICCID!="") {
                this.selectedDeviceId = <number>this.deviceIdData.find(x => x.description==this.selectedICCID)?.id ?? -1;

                this.provisioningForm.controls["deviceId"].setValue(this.selectedDeviceId);

                this.initialSelectedDeviceIdSet=true;
              } else if (this.deviceIdData.length == 0) {
                this.noICCIDData = true;
              }

            } else if (fieldName=="deviceTypeId") {
              this.deviceTypeIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialSelectedDeviceTypeIdSet && this.selectedDeviceTypeId != undefined && this.selectedDeviceTypeId>0) {
                this.provisioningForm.controls["deviceTypeId"].setValue(this.selectedDeviceTypeId);
                
                this.refreshDeviceData();

                this.initialSelectedDeviceTypeIdSet=true;
              } else  {
                this.refreshDeviceData();
              }

            } else if (fieldName=="productId") {
              this.productIdData=(data as IdAndDescriptionDTO[]);
              if (this.productIdData.length == 1) {
                this.provisioningForm.controls["productId"].setValue(this.productIdData[0].id);
              }
            } else if (fieldName=="inviewUserId") {
              this.inviewUserIdData=(data as InviewUserDTO[]);

              this.inviewUserSelectDropDownChange(undefined);
            }
           },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getInviewUserLabel(inviewUser: InviewUserDTO): string {
    try {
      return inviewUser.iotDevice ? (inviewUser.firstName ?? "") + " - " + (inviewUser.surname ?? "") : inviewUser.email;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return inviewUser?.email ?? "";
    }
  }

  //#endregion

  //#region Inview Company
  
  public refreshInviewCompanyData() {
    try {
      this.getDropdownData(this.inviewCompaniesService.getIdAndDescription(this.curUser.inviewUserId), "inviewCompanyId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public deviceSelectDropDownChange(event: Event | undefined) {
    try {
      let deviceId=this.provisioningForm.controls["deviceId"].value;
      this.initialSelectedDeviceIdSet = true;

      if (isNaN(deviceId) || deviceId=="") {
        deviceId=-1;
        this.provisioningForm.controls["iccid"].setValue("");
      }
      else {
        let iccid = this.deviceIdData.find(x => x.id==this.provisioningForm.controls["deviceId"].value)?.description ?? "";
        this.provisioningForm.controls["iccid"].setValue(iccid);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public deviceTypeSelectDropDownChange(event: Event | undefined) {
    try {
      this.deviceIdData       =[];
      let   deviceTypeId      =this.provisioningForm.controls["deviceTypeId"].value;
      const selectedDeviceType=this.deviceTypeIdData.find(x => x.id===deviceTypeId);

      this.physicalSimSelected=selectedDeviceType==undefined ? undefined : selectedDeviceType.description==TypeDevice.SIM;
      this.randomEsim         =true;
      this.reservedOnly       =this.physicalSimSelected ?? false;
      this.selectedICCID      ="";

      this.setOrClearValidators();

      if (isNaN(deviceTypeId) || deviceTypeId=="") {
        deviceTypeId=-1;
      }
      this.selectedDeviceTypeId = deviceTypeId;

      this.provisioningForm.controls["iccid"].setValue("");
      this.provisioningForm.controls["deviceId"].setValue(undefined);
      let gotDeviceType = deviceTypeId>0;      

      if (gotDeviceType) {
        this.noICCIDData = false;
        this.getDropdownData(this.devicesService.getAvailableIdAndDescription(deviceTypeId, <number>this.sureSimCompanyId, this.reservedOnly, this.availableOnly), "deviceId");
      } else {
        this.resetDeliveryStep();
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inviewCompanySelectDropDownChange(ev: any) {
    try {
      this.resetMainVariables(false, true);
      this.enableDisableControls(false);
      this.provisioningForm.controls["inviewUserId"].setValue("");
      if (this.reservedOnly && this.initialSelectedDeviceIdSet == true) {
        this.initialSelectedDeviceIdSet=false;
        this.provisioningForm.controls["iccid"].setValue("");
        this.provisioningForm.controls["deviceId"].setValue(undefined);
        this.selectedDeviceId     = -1;
        this.selectedICCID        = "";
      }

      this.selectedInviewCompany=this.inviewCompanyIdData.find(x => x.id==this.provisioningForm.get('inviewCompanyId')?.value);
      let gotCompany            =this.selectedInviewCompany?.id!=undefined && <number>this.selectedInviewCompany?.id>0;      

      if (gotCompany) {
        this.selectedInviewCompanyId=<number>this.selectedInviewCompany?.id;

        this.companiesService.getIdByCompanyName(this.selectedInviewCompany?.description ?? "")
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.sureSimCompanyId=data.result;
            this.userCanProvision(this.sureSimCompanyId);
            //this.refreshReservationCount(this.initialOrderStatus);
            this.getTemplateData(MessageType.ProvisioningViaEmail,  DeliveryType.Email);
            this.getTemplateData(MessageType.ProvisioningViaSMS,    DeliveryType.SMS);
            this.getTemplateData(MessageType.ProvisioningViaManual, DeliveryType.Email);
            this.getTemplateReplacements();

            if (this.sureSimCompanyId<=0) {
              this.registerInviewCompany=true;
              this.alertColourProgress  =AlertClassColour.Red;
              this.progressInformation  =`${this.selectedInviewCompany?.description} is not ${ApplicationNames.eSimPlatform} registered`;
              this.warningMessageMain   ="Company not registered";
              this.warningMessageSub    =`The selected company is not registered on the ${ApplicationNames.eSimPlatform} and must be registered before continuing`;
              
              this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);

            } else {
              this.enableDisableControls(true);

              this.progressInformation=`${this.selectedInviewCompany?.description} is ${ApplicationNames.eSimPlatform} registered`;
              this.alertColourProgress=AlertClassColour.Green;

              this.refreshProductData();
            }

            this.refreshInviewUserData();
            this.refreshDeviceTypeData();
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addInviewCompany() {
    try {
      if (this.registerInviewCompany) {
        this.selectedInviewCompanyId=<undefined>this.selectedInviewCompany?.id;

      } else {
        this.selectedInviewCompanyId=modalFormValues.createNewCompanyId;
      }

      this.companyModalForm.openForm(0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inviewCompanyHasBeenSaved(inviewCompanyId: number | undefined) {
    try {
      if (inviewCompanyId != undefined && inviewCompanyId>0) {
        this.registerInviewCompany=false;

        this.provisioningForm.controls["inviewCompanyId"].setValue(inviewCompanyId);
        
        this.refreshInviewCompanyData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setOrClearValidators() {
      this.validatorService.setOrClearValidators(this.provisioningForm,
                                                 "eid",
                                                 !(this.physicalSimSelected == undefined || this.physicalSimSelected == true || this.deliveryMethod == 'sms' || this.deliveryMethod == 'email' || this.deliveryMethod == 'manual'),
                                                 [Validators.required, Validators.minLength(32), Validators.maxLength(32), Validators.pattern('^[0-9]{32,32}$')]);

      this.validatorService.setOrClearValidators(this.provisioningForm,
                                                 "deviceId",
                                                 (this.physicalSimSelected == undefined || this.physicalSimSelected == true),
                                                 [Validators.required]);
  }

  //#endregion

  //#region Inview User
  
  private refreshInviewUserData() {
    try {
      this.inviewUserIdData=[];
                             
      if (this.selectedInviewCompany?.id != undefined && <number>this.selectedInviewCompany?.id>0) {
                             
        this.inviewUsersService.getCompanyUsersCount(<number>this.selectedInviewCompany?.id, undefined)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (data["result"]
                >
                this.configSystemService.getValueAsInteger(ConfigSystemParams.InviewUserListLimit, ConfigSystemParamDefaults.InviewUserListLimit)) {
                           
              this.searchForInviewUser=true;
              this.provisioningForm.controls["inviewUserId"].disable();
                             
            } else {
              this.provisioningForm.controls["inviewUserId"].enable();
              this._refreshInviewUserData();
            }
                             
           },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public _refreshInviewUserData() {
    try {
      if (this.selectedInviewCompany?.id != undefined && <number>this.selectedInviewCompany?.id>0) {
        this.getDropdownData(this.inviewUsersService.getByCompanyId(<number>this.selectedInviewCompany?.id ?? -1), "inviewUserId");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private refreshSureSimUserData(): void {
    try {
      if (this.sureSimUserId == undefined || this.sureSimUserId<=0) {
        return;
      }

      this.usersService.getById(this.sureSimUserId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.selectedSureSimUser=data;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inviewUserSelectDropDownChange(ev: any) {
    try {
      this.registerInviewUser    =false;
      this.selectedInviewUser    =this.inviewUserIdData.find(x => x.userID==this.provisioningForm.get('inviewUserId')?.value);
      this.selectedInviewUserId  =undefined;
      this.selectedSureSimUser   =undefined;
      let gotUser                =this.selectedInviewUser?.userID!=undefined && <number>this.selectedInviewCompany?.id>0;
      
      if (gotUser) {
        this.selectedInviewUserId=<number>this.selectedInviewUser?.userID;

        this.usersService.getIdByUsername(this.sureSimCompanyId ?? 0, this.selectedInviewUser?.email ?? "")
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.sureSimUserId=data.result;

            if (this.sureSimUserId<=0) {
              this.registerInviewUser =true;
              this.progressInformation=`${this.selectedInviewUser?.email} is not ${ApplicationNames.eSimPlatform} registered`;
              this.alertColourProgress=AlertClassColour.Red;

              if (!this.searchForInviewUser) {
                this.warningMessageMain="User not registered";
                this.warningMessageSub =`The selected user is not registered on the ${ApplicationNames.eSimPlatform} and must be registered before continuing`;
                this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
              }

            } else {
              this.progressInformation   =`${this.selectedInviewUser?.email} is ${ApplicationNames.eSimPlatform} registered`;
              this.alertColourProgress   =AlertClassColour.Green;

              this.refreshSureSimUserData();
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public addInviewUser() {
    try {
      if (this.registerInviewUser) {
        this.selectedInviewUserId=<undefined>this.selectedInviewUser?.userID;

      } else {
        this.selectedInviewUserId=modalFormValues.createNewUserId;
      }

      this.userModalForm.openForm(0, eUser.sim);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inviewUserDataHasBeenSaved(inviewUserId: number | undefined) {
    try {
      if (inviewUserId != undefined && <number>inviewUserId>0) {
        this.registerInviewUser    =false;
        this.provisioningForm.controls["inviewUserId"].value
        this.provisioningForm.controls["inviewUserId"].setValue(inviewUserId);

        if (this.searchForInviewUser) {
          this.createAndSelectSearchedUser(inviewUserId);
        
        } else {
          this.refreshInviewUserData();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#region Inview User Search
                      
  public _searchForInviewUser() {
    try {
      this.userSearchForm.openForm(<number>this.selectedInviewCompany?.id, <string>this.selectedInviewCompany?.description);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                      
  public searchFormCancelled() {
    try {
      this.inviewUserIdData=[];
                        
      this.provisioningForm.controls["inviewUserId"].setValue(undefined);
      this.inviewUserSelectDropDownChange(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                      
  public searchFormHasBeenSaved() {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                      
  public searchGridRowClick(rowId: number) {
    try {
      this.createAndSelectSearchedUser(rowId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                      
  public createAndSelectSearchedUser(rowId: number) {
    try {
      this.inviewUsersService.getByUserId(rowId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          let selectedId       =undefined;
          this.inviewUserIdData=[];
                        
          if (data==null || data==undefined) {

            selectedId=modalFormValues.createNewUserId;

            this.inviewUserIdData.push({
              clIs                  : [],
              companyId             : 0,
              costCenterID          : 0,
              email                 : modalFormValues.createNewUser,
              existingToBePortalUser: false,
              firstName             : "",
              portalUser            : false,
              surname               : "",
              userID                : modalFormValues.createNewUserId,
              username              : ""
            });

            this.addInviewUser();

          } else {
            selectedId=data.userID;
                        
            if (data.cli != undefined) {
              data.clIs=[];
              data.clIs.push(data.cli);
            }
                    
            this.inviewUserIdData.push(data);
          }
                      
          this.provisioningForm.controls["inviewUserId"].setValue(selectedId);
          this.inviewUserSelectDropDownChange(undefined);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                      
  //#endregion

  //#endregion

  //#region SureSIM Product

  public refreshDeviceData() {
    try {
      this.noICCIDData=false;
      if (this.selectedDeviceTypeId != -1) {
        this.getDropdownData(this.devicesService.getAvailableIdAndDescription(this.selectedDeviceTypeId, <number>this.sureSimCompanyId, this.reservedOnly, this.availableOnly), "deviceId");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshDeviceTypeData() {
    try {
      this.getDropdownData(this.typesDeviceService.getIdAndDescription(), "deviceTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private resetDeliveryStep(): void {
    try {
      this.customiseMessageExpanded      =false;
      this.deliveryMethod                =this.showSMSEmail ? '' : 'eid';
      this.deviceType                    ='';
      this.manualActivationCode          =undefined;
      this.manualActivationDetailsVisible=false;
      this.manualActivationServer        =undefined;

      this.populateCustomiseMessage();

      this.setOrClearValidators();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public productSelectDropDownChange(event: Event | undefined) {
    try {
      if (!this.productSelected()) {
        this.resetDeliveryStep();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userSelected(): boolean {
    try {
      const inviewUserId=this.provisioningForm?.controls["inviewUserId"]?.value;

      return Number(inviewUserId ?? 0)>0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public productSelected(): boolean {
    try {
      const productId=this.provisioningForm?.controls["productId"]?.value;

      return productId != undefined && productId != null && productId != "" && Number(productId)>0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public refreshProductData() {
    try {
      this.getDropdownData(this.productsService.getAvailableIdAndDescription(-1, this.sureSimCompanyId ?? -1), "productId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Provisioning

  private addCustomError(controlName: string, errorKey: string, errorValue: any) {
    const control = this.provisioningForm.get(controlName);
    if (control) {
      control.setErrors({ ...control.errors, [errorKey]: errorValue });
    }
  }
  
  private doProvisioning(esimProvisioningDTO : EsimProvisioningDTO): void {
    try {
      if (!this.provisioningInProgress) {
        this.provisioningInProgress = true;
  
        this.devicesService.provisionNextAvailableDevice(esimProvisioningDTO)
        .pipe(
          catchError((error) => {
            this.provisioningInProgress = false;
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.device=data;
            this.provisioningForm.controls["iccid"].setValue(this.device.imeiIccid);
            this.orderStatusInformation = this.completedOrderStatus;
  
            if (data.deviceTypeID == eDeviceType.esim) {
              this.exsitingReservedeSimsCount = Number(this.exsitingReservedeSimsCount) - 1;
            } else if (data.deviceTypeID == eDeviceType.sim) {
              this.exsitingReservedSimsCount = Number(this.exsitingReservedSimsCount) - 1;
            }
            this.updateProvisioningStatus(this.orderStatusInformation, this.reservedOnly);
  
            if (!this.embeddedFormMode) {
              this.randomEsim=false;
              this.statusObservable = timer(0, 50000);
              this.statusObservable.pipe(takeUntil(this.statusCheck)).subscribe(() => this.getWebbingOrderStatus());
            } 
  
            this.provisioningInProgress = false;

            if (this.deliveryMethod === 'manual') {
              this.iccidHasBeenProvisioned.emit();

              if (data.activationServer != undefined && data.activationServer != '') {
                this.manualActivationServer         = data.activationServer;
                this.manualActivationCode           = data.activationCode;
                this.manualActivationDetailsVisible = true;
              }

              this.showMessageWarning(data.messageError);

            } else if (data.messageError != undefined && data.messageError != '') { //RBW_20260827 - The SIM is provisioned, only the message failed
              this.iccidHasBeenProvisioned.emit();
              this.showMessageWarning(data.messageError);
              this.completedModalHasBeenClosed();

            } else {
              this.processComplete();
            }
          },
          error: error => {
            if (error.message && error.message.includes("404")) {
              this.provisioningInProgress = false;
              this.enableDisableControls(false);
  
              this.warningMessageMain="There are no eSIMs available";
              this.warningMessageSub ="Please contact the application vendor for assistance";
  
              this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else if (error.message && error.message.includes("Failed searching for next available sim")) {
              this.provisioningInProgress  = false;
              this.enableDisableControls(true);
              this.addCustomError('deviceId', 'alreadyProvisioned', 'Please select different ICCID, this one is no longer available');
  
            } else {
              this.provisioningInProgress = false;
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.provisioningInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getProvisionButtonText() {
    var buttonText = "Provision";
    if (this.deliveryMethod === 'email' ) {
       buttonText = "Provision via email";
    } else if (this.deliveryMethod === 'sms')  {
       buttonText = "Provision via SMS";
    } 
    return buttonText;
  }

  private getWebbingOrderStatus() {
    try {
      this.devicesService.getByImeiIccid(this.device?.imeiIccid ?? "")
       .pipe(
         catchError((error) => {
        this.provisioningInProgress = false;
        return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
       }))
       .subscribe({
        next: data => {
          if (data.status != "" && data.status != null)
          {
            this.orderStatusInformation=data.status;
            this.updateProvisioningStatus(this.orderStatusInformation, this.reservedOnly);
          }
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            // this.enableDisableControls(false);
  
            // this.warningMessageMain="There are no eSIMs available";
            // this.warningMessageSub ="Please contact the application vendor for assistance";
  
            // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else {
            // this.exceptionsService.handleException(new Error(error));
          }
        }
        });
     }
     catch(e) {
      this.provisioningInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public isProvisionButtonEnabled() {
    return (((this.deliveryMethod === 'eid'    && this.provisioningForm.controls['eid'].value != '') ||
             (this.deliveryMethod === 'email'  && this.deviceType != '') ||
             (this.deliveryMethod === 'sms'    && this.deviceType != '') ||
             (this.deliveryMethod === 'manual') || 
             this.physicalSimSelected) && this.provisioningForm.valid && (this.totalRemainingLicences > 0 || !this.mustHaveLicence)) && !this.provisioningInProgress && !this.manualActivationDetailsVisible && this.customiseMessageIsValid(); //RBW_20260707 - Once a manual provision has completed, block re-provisioning against the same details until the form is reset.
  }

  //#endregion

  //#region Process Complete

  private showMessageWarning(messageError: string | undefined): void {
    try {
      if (messageError == undefined || messageError == '') {
        return;
      }

      this.warningMessageMain=(this.deliveryMethod === 'sms' ? "The SIM was provisioned but the SMS could not be sent"
                                                            : "The SIM was provisioned but the email could not be sent");
      this.warningMessageSub =messageError;

      this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private processComplete() {
    try {
      var deviceType = "eSIM";
      if (this.provisioningForm.controls["deviceTypeId"].value != eDeviceType.esim) {
        deviceType = "SIM";
      }

      this.completedModalForm.openForm("Congratulations", deviceType + " " + this.device?.imeiIccid + " has been provisioned");
      this.iccidHasBeenProvisioned.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetManualForm() {
    try {
      this.completedModalHasBeenClosed();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    try {
      if (this.embeddedFormMode) {
        this.selectedDeviceTypeId = -1;
        this.selectedDeviceId     = -1;
        this.selectedICCID        = "";
        this.startProcess(false);
      } else {
        this.disableAllControls(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public getTotalReservedeSimCount() {
    try {
      this.dashboardService.getTotalReservedeSimCount(this.sureSimCompanyId  ?? -1, 2025, 1, 1)
                                                      // <number>this.filterDate.year,
                                                      // <number>this.filterDate.month,
                                                      // <number>this.filterDate.day)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
            this.exsitingReservedeSimsCount  = Number(data.currentTotal);
            this.getTotalReservedSimCount();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public getTotalReservedSimCount() {
    try {
      this.dashboardService.getTotalReservedSimCount(this.sureSimCompanyId  ?? -1, 2025, 1, 1)
                                                    //  <number>this.filterDate.year,
                                                    //  <number>this.filterDate.month,
                                                    //  <number>this.filterDate.day)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
            this.exsitingReservedSimsCount= Number(data.currentTotal);
            this.orderStatusInformation    = this.initialOrderStatus;
            this.updateProvisioningStatus(this.orderStatusInformation, this.reservedOnly);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  // public refreshReservationCount(status:string) {
  //   try {
  //     this.exsitingReservedSimsCount  = 0;
  //     this.exsitingReservedeSimsCount = 0;
  //     this.getTotalReservedeSimCount();
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

  public updateProvisioningStatus(status:string, includeSimReservationInfo:boolean) {
    try {
      // if (includeSimReservationInfo == true) {
      //   this.orderStatusInformation = status + `  (Remaining reservations, ${this.exsitingReservedSimsCount} sims, ${this.exsitingReservedeSimsCount} esims)`;
      // } else {
        this.orderStatusInformation = status;
      // }


    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region System Licence Check & Possible Lockdown

  public userCanProvision(companyId: number | undefined) {
    try {
      if (this.mustHaveLicence) {
        //this.warningModalForm.closeForm();

        if (companyId && Number(companyId)>0) {
          this.devicesService.totalLiveDevicesForCompany(companyId)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.totalLiveDevices=data.result;
              
              this.licencesCompanyAllocatedService.totalLivePlatformLicencesForCompany(companyId)
              .pipe(
                catchError((error) => {
                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                })
              )
              .subscribe({
                next: data => {
                  this.totalPlatformLicences =data.result;
                  this.totalRemainingLicences=this.totalPlatformLicences-this.totalLiveDevices;
                  if (this.totalRemainingLicences <= 0) {
                    this.totalRemainingLicences = 0;
                    this.usedLicencePercentage  = 100;
                  } else if(this.totalLiveDevices == 0) {
                    this.usedLicencePercentage = 0
                  } else {
                    this.usedLicencePercentage = (this.totalLiveDevices / this.totalPlatformLicences * 100);
                  }

                  if (this.totalLiveDevices>=this.totalPlatformLicences) {
                    //this.warningModalForm.openForm("Cannot proceed", Company has a total of ${totalPlatformLicences} licences and ${totalLiveDevices} have been used`);
                    this.progressInformation=`Cannot Proceed - ${this.selectedInviewCompany?.description} has a total of ${this.totalPlatformLicences} licences and ${this.totalLiveDevices} ${this.totalLiveDevices==1 ? "has" : "have"} been used`;
                    this.alertColourProgress=AlertClassColour.Red;
                    this.disableAllControls(false);

                  } else {
                    this.progressInformation=`Can Proceed - ${this.selectedInviewCompany?.description} has a total of ${this.totalPlatformLicences} licences and ${this.totalLiveDevices} ${this.totalLiveDevices==1 ? "has" : "have"} been used`;
                    this.alertColourProgress=AlertClassColour.Green;
                  }
                },
                error: error => {
                  this.exceptionsService.handleException(new Error(error));
                }
              });
            },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });

        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
